import { render, staticRenderFns } from "./shoucang.vue?vue&type=template&id=9394449a"
import script from "./shoucang.vue?vue&type=script&lang=js"
export * from "./shoucang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports